import type { FunctionComponent } from 'react'

import { FaqQuestion } from '../../components/FaqQuestion'

export const BudgetHelperFaq: FunctionComponent = () => {
	return (
		<div>
			{[...Array(11).keys()].map((i) => {
				const questionNumber = i + 1
				return (
					<FaqQuestion
						key={`FAQ::QUESTION_${questionNumber}`}
						questionKey={`budgetHelper-faq-question${questionNumber}`}
						answerKey={`budgetHelper-faq-answer${questionNumber}`}
					/>
				)
			})}
		</div>
	)
}
